import api from '@/helpers/api';
import store from '@/store';

// TODO refactor all the validators


// import { Validator } from 'vee-validate';
// import dictionary from './locale/validator';

// Validator.localize(dictionary);
// Validator.extend('greater', (fieldValue, [value]) => fieldValue > value, {
//   hasTarget: true,
// });

// /**
//  * Validator for bulk contacts and tags
//  */
// const bulkRule = {
//   getMessage(field, params, data) {
//     return (data && data.message) || 'Invalid input';
//   },
//   validate(value) {
//     return new Promise((resolve) => {
//       resolve({
//         valid: ((value.tags && value.tags.length > 0) || (value.contacts && value.contacts.length > 0)),
//         data: { message: 'Please select at least one contact or tag' },
//       });
//     });
//   },
// };
// Validator.extend('checkBulk', bulkRule);

// /**
//  * Phone number validator.
//  * Consider using libphonenumber as a helper in the future. It requires setting a locale which may be an issue.
//  */
// const phoneRule = {
//   getMessage(field, params, data) {
//     return (data && data.message) || 'Invalid input';
//   },
//   validate(value) {
//     return new Promise((resolve) => {
//       const phoneRegex = new RegExp('^\\+?([0-9]{1,3})\\)?[-. ]?([0-9]{1,4})?[-. ]?([0-9]{3,7})[-. ]?([0-9]{3,7})$', '');
//       resolve({
//         valid: (phoneRegex.test(value)),
//         data: { message: 'Please input a valid phone format. (+xxx xx xxx xxxx)' },
//       });
//     });
//   },
// };
// Validator.extend('sbPhone', phoneRule);

// /**
//  * SMS code validator.
//  */
// const smsCodeRule = {
//   getMessage(field, params, data) {
//     return (data && data.message) || 'Invalid input';
//   },
//   validate(value) {
//     return new Promise((resolve) => {
//       let is4digit = true;
//       if (value && value.length === 4) {
//         for (let index = 0; index < value.length; index++) {
//           if (Number.isNaN(parseInt(value[index], 10))) {
//             is4digit = false;
//           }
//         }
//       } else {
//         is4digit = false;
//       }
//       resolve({
//         valid: (is4digit),
//         data: { message: 'Please input a 4 digit code.' },
//       });
//     });
//   },
// };
// Validator.extend('sbSMSCode', smsCodeRule);

// export default Validator;

import { extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import { parsePhoneNumber } from 'libphonenumber-js';

extend('email', {
  ...email,
  message: 'Email is invalid.',
});

extend('required', {
  ...required,
  // message: '{_field_} is required.',
  message: 'This field is required.',
});

extend('requiredDefaultMessage', {
  ...required,
  message: 'Required field.',
});

extend('phone', {
  validate(value, [fullNumber]) {
    const plusVersionOfNumber = value.replace(/^00/, '+');
    let parsedPhone;
    let phoneValid;

    try {
      parsedPhone = parsePhoneNumber(plusVersionOfNumber, { extract: false, defaultCountry: fullNumber === 'full' ? null : store.getters['user/region'] });
      phoneValid = !!(
        parsedPhone &&
        parsedPhone.isValid()
      );
    } catch (error) {
      phoneValid = false;
    }

    return phoneValid;
  },
  message: 'Phone format is invalid.',
});

/**
 * We are still not using this anywhere since we agreed that we will allow template names in any script and submit to fb and gupshup in latin
 */
extend('latinOnly', {
  validate(value) {
    // Regex version which would allow čćž..., cirilic and other languages in unicode would be
    // ^[ \p{Letter}0-9!-\/:-@[-`{-~]+$     /u (do not forget the 'u' modifier)
    const latinRegex = new RegExp('^[ A-Za-z0-9!-\\/:-@[-`{-~]+$');
    return latinRegex.test(value);
  },
  message: 'You can use only a-z letters, numbers and special characters.',
});

extend('tooLong', {
  params: ['max', 'current', 'message'],
  validate(_, { max, current }) {
    return current <= max;
  },
  message: '{message}',
});

extend('noNeighbourPlaceholders', {
  validate(value) {
    const neighboursRegex = new RegExp('\\<code\\>\\d\\<\\/code\\>(\\s*\\<code\\>\\d\\<\\/code\\>)+', '');
    return !neighboursRegex.test(value);
  },
  message: 'Multiple placeholders can\'t be next to each other.',
});

extend('noStartingPlaceholder', {
  validate(value) {
    const startingRegex = new RegExp('^(\\<p\\>)?\\<code\\>\\d\\<\\/code\\>', '');
    return !startingRegex.test(value);
  },
  message: 'Message can\'t start with a placeholder.',
});

extend('noEndingPlaceholder', {
  validate(value) {
    const endingRegex = new RegExp('\\<code\\>\\d\\<\\/code\\>\\s*(<\\/p>)?$', '');
    return !endingRegex.test(value);
  },
  message: 'Message can\'t end with a placeholder.',
});

extend('noPlaceholderNewline', {
  validate(value) {
    const newlineRegex = new RegExp('\\<code\\>\\d\\<\\/code\\>\\s*\\<\\/p\\>\\n?\\<p\\>', '');
    return !newlineRegex.test(value);
  },
  message: 'There can\'t be a newline after a placeholder.',
});

extend('url', {
  validate(value) {
    return (/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/gi).test(value);
  },
  message: 'Url is invalid.',
});

extend('urlPrefixed', {
  validate(value) {
    return value.match(/^http[s]*:\/\/[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:\/?#[\]@!\$&'\(\)\*\+,;=.%:]+$/gi);
  },
  message: 'Invalid URL. URLs must begin with “https://“ or “http://“',
});

/**
 * TaxID validation should validate user tax id on input but we do not have time for it right now.
 * There is a potentially good api here - https://taxid.pro/pricing
 *
 * Tax validation is done on backend at the moment. Maybe we don't even need frontend validation
 */
extend('taxId', {
  validate(value) {
    // console.log('VALIDATE', value);
    return true;
  },
  message: '{_field_} is invalid.',
});

/** Field is required if a refferenced field has value */
// NOTE do not use this. This can be accomplished by using dynamic required rule on the component. Search requiredIf in code for example.
extend('requiredIf', {
  params: ['targetName', 'targetValue'],
  validate(value, { targetValue }) {
    return !(!!targetValue && !value);
  },
  message: '{_field_} is required if you populate the {targetName}',
});

extend('blockKeyword', {
  validate(value, [keyword, caseSensitive]) {
    const regex = new RegExp(`^${keyword}$`, caseSensitive === 'true' ? 'g' : 'gi');
    return !value.match(regex);
  },
  message: 'Stop keyword is already being used to enable contacts to unsubscribe.',
});

/** Checks if the value matches with provided 'matchTo' parameter. Usefull for validating password change. */
extend('matchMe', {
  params: ['matchTo', 'message'],
  validate(firstValue, { matchTo }) {
    return firstValue === matchTo;
  },
  message: '{message}',
});

/**
 * Checks if field has parameter 'valid' and that it is set to true.
 * Usefull when there is a component used inside the ValidatationObserver and that component allready has a validator but we also need to validate it from the parent to enable the submit button.
 */
extend('validChild', {
  validate(value) {
    return !!value.valid;
  },
});

/**
 * Allows you to test if there is a duplicate already present.
 *
 * Called like this on the ValidationProvider component.
 * :rules="{
 *    required: true, // this is optional. Placed here just to show how multiple rules can be added to the same validation.
 *    noDuplicate: {
 *      list: [LIST_OF_ITEMS],
 *      caseSensitive: BOOLEAN,
 *      message: 'Message to be shown in case of error.'
 *    }
 *  }"
 */
extend('noDuplicate', {
  params: ['list', 'caseSensitive', 'message'],
  validate(value, { list, caseSensitive }) {
    let valid = false;
    if (caseSensitive) {
      valid = !list.includes(value);
    } else {
      valid = !list.find(li => li.toLowerCase() === value.toLowerCase());
    }

    return valid;
  },
  message: '{message}',
});

/**
 * Allows you to test if there is a duplicate already present but checks it on all .
 *
 * Called like this on the ValidationProvider component.
 * :rules="{
 *    required: true, // this is optional. Placed here just to show how multiple rules can be added to the same validation.
 *    noDuplicate: {
 *      list: [LIST_OF_ITEMS],
 *      caseSensitive: BOOLEAN, // optional
 *      message: 'Message to be shown in case of error.'
 *    }
 *  }"
 */
extend('noDuplicateRemote', {
  params: ['endpoint', 'caseSensitive', 'message'],
  async validate(value, { endpoint, caseSensitive = false }) {
    let valid = false;

    await api('GET', endpoint, { name: value, exact: true, case_sensitive: caseSensitive, noCancel: true }, null, 'w')
      .then((response) => {
        if (
          response.status === 200 &&
          response.data.data.length === 0
        ) {
          valid = true;
        }
      });
    return valid;
  },
  message: '{message}',
});

/**
 * Validates the value agains some data in the store or via remote endpoint provided in the params.
 * @param {String} storePath Store path. For formSchema stores the module name is not needed.
 * @param {String} endpoint  Endpoint to fetch if the store is empty.
 * @param {String} param     Param name to check in the list object.
 * @param {String} storeMutation Store mutation to commit if the store is empty.
 * 
 * TODO - make this more generic since the fallback mutation now is SET_ORGANISATION_AI_ASSISTANTS.
 */
extend('checkDuplicate', {
  params: ['ignoreValue', 'storePath', 'endpoint', 'param', 'storeMutation'],
  async validate(value, {
    ignoreValue,
    storePath,
    endpoint,
    param,
    storeMutation,
  }) {
    return new Promise(async (resolve) => {
      if (value === ignoreValue) {
        resolve({ valid: true });
      }
      let valid = false;
      const finalStorePath = storePath.includes('/') ? storePath : `formSchema/${storePath}`;
      let list = store.getters[finalStorePath];

      const checkExisting = () => list && Array.isArray(list) && list.some(l => l[param] === value);

      if (list && Array.isArray(list) && list.length) {
        valid = !checkExisting();
        resolve({ valid });
      } else if (list === 'fetching') {
        // In case the endpoint is in fetching state then wait for it and check the data when it is done
        let counter = 0;
        // Interval will run maximum 10 times preventing the endless loop.
        const checkInterval = setInterval(() => {
          counter++;
          list = store.getters[finalStorePath];
          if (counter >= 10 || (list && list !== 'fetching')) {
            clearInterval(checkInterval);
            valid = !checkExisting();
            resolve({ valid });
          }
        }, 500);
      } else {
        if (storeMutation) {
          store.commit(storeMutation, 'fetching');
        } else {
          store.commit('organisation/SET_ORGANISATION_AI_ASSISTANTS', 'fetching');
        }
        await api('GET', endpoint, { noCancel: true, noPrefix: true })
          .then((response) => {
            if (response.status === 200 && response.data.length) {
              if (storeMutation) {
                store.commit(storeMutation, response.data);
              } else {
                store.commit('organisation/SET_ORGANISATION_AI_ASSISTANTS', response.data);
              }
              valid = !checkExisting();
              resolve({ valid });
            } else {
              if (storeMutation) {
                store.commit(storeMutation, []);
              } else {
                store.commit('organisation/SET_ORGANISATION_AI_ASSISTANTS', []);
              }
              valid = true;
              resolve({ valid });
            }
          });
      }
      // resolve({ valid });
    });
  },
  message: 'This name is already taken.',
});

const noSpecialCharactersRule = {
  params: ['message'],
  validate(value) {
    return value.match(/^[a-z0-9\s]+$/gi);
  },
  message: '{message}',
};
extend('noSpecialCharacters', noSpecialCharactersRule);

extend('number', {
  params: ['message'],
  validate(value) {
    return Number(value) || Number(value) === 0;
  },
  message: (fieldName, placeholders) => placeholders.message || 'Invalid format. Only numbers are allowed',
});

extend('minNumber', {
  params: ['min', 'message', 'formatMessage'],
  validate(value, { min }) {
    return value >= min;
  },
  message: (fieldName, placeholders) => placeholders.message || `Please enter a number greater than ${placeholders.min}.`,
});

extend('maxNumber', {
  params: ['max', 'message'],
  validate(value, { max }) {
    return value <= max;
  },
  message: (fieldName, placeholders) => placeholders.message || `Please enter a number less than ${placeholders.max}.`,
});

extend('noDecimals', {
  params: ['message'],
  validate(value) {
    return value && value.includes && !value.includes('.');
  },
  message: (fieldName, placeholders) => placeholders.message || 'Decimal places are not allowed.',
});

extend('minLength', {
  params: ['min'],
  validate(value, { min }) {
    return value.length >= min;
  },
  message: 'Please make your text a bit more descriptive.',
});

extend('maxLength', {
  params: ['max'],
  validate(value, { max }) {
    return value.length <= max;
  },
  // message: 'Can you make your text a bit shorter, please?',
  message: 'Please limit your text to {max} characters.',
});

extend('urlPath', {
  validate(value) {
    // const regex = new RegExp('^[\\/]?[^.\\n][-a-zA-Z0-9@:%_\\+~#=\\/]+(?:\\.[a-zA-Z0-9()]{1,10})?(?:[-a-zA-Z0-9()@:%_\\+.~#?&=]*|(?:(?<!\\.[a-zA-Z0-9()]{1,10}\\/)(?:\\*))?|((?<!\\.[a-zA-Z0-9()]{1,10})(\\/))?)$', '');
    const regex = new RegExp('^\\/?(?:(?:[A-Za-z0-9_!-]+\\/)*[A-Za-z0-9_!-]+\\.[A-Za-z0-9_!-]+(?:\\?.*)?|(?:[A-Za-z0-9_!-]+\\/)*[A-Za-z0-9_!-]+(?:\\/(?:\\*)?)?(?:\\?.*)?)$', '');
    return value.match(regex);
  },
  message: 'Path is invalid.',
});

extend('urlPathOnlyWildcard', {
  validate(value) {
    const regex = new RegExp('^\\/{0,1}?([a-zA-Z0-9-]*[a-zA-Z0-9]+\\/)+(\\*)$', '');
    return value.match(regex);
  },
  message: 'Path is invalid.',
});

extend('uniques', {
  params: ['list'],
  validate(value, { list }) {
    if (!list || !Array.isArray(list)) return true;
    const filteredValue = list.filter(l => l === value);
    return filteredValue.length === 1;
  },
  message: 'This link already exists.',
});

extend('externalUniques', {
  params: ['list'],
  validate(value, { list }) {
    if (!list || !Array.isArray(list)) return true;
    const filteredValue = list.filter(l => l === value);
    return !filteredValue.length;
  },
  message: 'You can\'t reuse a path or page that\'s already in use by another filter.',
});
